<template>
  <v-container>
    <v-row>
      <v-col class="mb-2">
        <CustomerBase :customer="customer" :users="users" />
      </v-col>
    </v-row>
    <v-tabs v-if="customertabs" v-model="activeTab">
      <v-tab v-for="tab in customertabs" :key="tab.label" @click="visitTab(tab)">
        {{ tab.label }}
      </v-tab>
    </v-tabs>
    <v-row>
      <v-col>
        <ProcessTable :leads="leads" :processes="process" :customer="customer" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Verträge
          </v-card-title>
          <IndexTable :contracts="fulfilled" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import axios from 'axios'
import { formattedDateTimeString } from '@/plugins/formatDate.js'
import ProcessTable from '@/Components/Customer/Offers/ProcessTable'
// import FulfilledTable from '@/Components/Customer/Offers/FulfilledTable'
import IndexTable from '@/Components/Contract/Snippets/IndexTable'
import CustomerBase from '@/Components/Customer/CustomerBase'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.customer.name ? this.customer.name : 'Loading...',
      }
   },
   components: {
      ProcessTable,
      IndexTable,
      CustomerBase
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      customer: {
         type: Object,
         required: true,
      },
      leads: {
         type: Array,
         required: true,
      },
      process: {
         type: Array,
         required: true,
      },
      fulfilled: {
         type: Array,
         required: true,
      },
      users: {
         type: Array,
         required: true,
      },
      customertabs: {
         type: Array,
         required: true,
      },
   },

   data () {
      return {
         dialog: false,
         angebote: [],
         suche: '',
         headers: [
            { text: '#', value: 'number' },
            { text: 'Status', value: 'status' },
            { text: 'Angebots-Nr.', value: 'offer_id' },
            { text: 'Kunde', value: 'name' },
            { text: 'Mitarbeiter', value: 'performer_full_name' },
            { text: 'Datum', value: 'order_date' },
            { text: 'Actions', value: 'actions', sortable: false, width: '20%' },
         ],
         term: 3,
         terms: [
            { text: '36 Monate', value: 2 },
            { text: '60 Monate', value: 3 },
         ],
         publishOffer: null,
         performers: [],
         performer: null,
         showDeclined: false,
         activeTab: 0,
         searchContracts: ''
      }
   },
   watch: {
      customertabs: function () {
         for (const key in this.customertabs) {
            if (!this.customertabs[key].route) {
               this.activeTab = parseInt(key)
               return
            }
         }
      },
   },
   created () {
      for (const key in this.customertabs) {
         if (!this.customertabs[key].route) {
            this.activeTab = parseInt(key)
            return
         }
      }
   },
   methods: {
      createOffer () {
         this.$inertia.post(this.route('offerData.store', this.customer.id))
      },
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      async getPerformers (value) {
         await axios.get('/api/users').then((response) => {
            const performers = response.data.reduce((returnObj, person, index) => {
               returnObj[index] = {
                  id: person.id,
                  contactPersonId: person.contact_person.id,
                  fullName:
              person.contact_person.first_name +
              ' ' +
              person.contact_person.last_name,
               }
               return returnObj
            }, [])
            const performer =
          performers.find((performer) => {
             return performer.fullName === value
          }).contactPersonId ?? null
            this.setPerformer(performer, performers)
         })
      },
      setPerformer (performer, performers) {
         this.performer = performer
         this.performers = performers
      },
      async savePerformer (offerData) {
         await axios
            .patch(`/api/offerData/${offerData}/performer`, {
               performer: this.performer,
            })
            .then((response) => {
               this.angebote = response.data
            })
      },
      deleteItem (item) {
         if (confirm(`Soll das Angebot ${item.id} wirklich gelöscht werden?`)) {
            this.$inertia.delete(this.route('positionitem.delete', item.id))
         }
      },
      setPublishOffer (item) {
         this.publishOffer = item
         this.dialog = true
      },
      publishItem () {
         this.$inertia.post(
            this.route('offer.store', {
               offerData: this.publishOffer.id,
               term: this.term,
            })
         )
      },
      async duplicateItem (item) {
         await axios
            .post(`/api/offerData/${item.id}/replicate`)
            .then((response) => {
               console.log(response)
               // this.editItem(response.data.id);
            })
            .catch((error) => {
               console.log(error.response)
            })
      },
      visitTab (tab) {
         if (tab.route) {
            this.$inertia.visit(tab.route)
         }
      },
   },
}
</script>
